export enum BriefMode {
  AI = "AI",
  Manual = "Manual",
}
